import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { getBrandFeatureName } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusControl/GrubhubSeamlessPlusControl.utils';
import { ConfirmPlusFeatureCancellation } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusControl/ConfirmPlusFeatureCancellation';
import { useUnselectCheckboxConfirmation } from 'src/components/enterprise/features/Corporate/components/Form/GrubhubSeamlessPlusWrapper/GrubhubSeamlessPlusControl/hooks/useUnselectCheckboxConfirmation';

export interface GrubhubSeamlessPlusControlProps {
  name: string;
  id: string;
}

export function GrubhubSeamlessPlusControl({
  name,
  id,
}: GrubhubSeamlessPlusControlProps): JSX.Element {
  const { control } = useFormContext();
  const {
    confirmationModalOpen,
    setFieldValue,
    onChangeCheckedFeature,
    closeConfirmationModal,
  } = useUnselectCheckboxConfirmation(name);
  const brandOption = useWatch({ control, name: 'brand' }) as string;
  const plusBrandName = getBrandFeatureName(brandOption);

  return (
    <>
      <CookbookCheckboxWrapper
        control={control}
        id={id}
        name={name}
        label={plusBrandName}
        onChange={onChangeCheckedFeature}
      />
      {confirmationModalOpen && (
        <ConfirmPlusFeatureCancellation
          onConfirm={setFieldValue}
          plusBrandName={plusBrandName}
          onClose={closeConfirmationModal}
        />
      )}
    </>
  );
}
